import React from 'react'
import * as PropTypes from 'prop-types'
import {InferPropTypes} from '@modifi/typescript-utils'
import {Svg} from '@modifi/ui'

const propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
}
const defaultProps = {
  color: 'currentColor',
  width: 16,
  height: 16,
}

type DocumentUploadingIconProps = InferPropTypes<typeof propTypes, typeof defaultProps>

const DocumentUploadingIcon: React.FC<DocumentUploadingIconProps> = ({color, ...props}) => (
  <Svg viewBox="0 0 49 49" color="#fff" {...props}>
    <path
      d="M40.582 15.4694L30.7222 5.60967L28.9295 4.41455L28.0332 5.60967L28.6308 16.3658L40.582 16.9633V15.4694Z"
      fill="white"
    />
    <path
      d="M29.6042 4.08337H12.2501C11.1671 4.08337 10.1285 4.51358 9.36273 5.27935C8.59695 6.04513 8.16675 7.08374 8.16675 8.16671V40.8334C8.16675 41.9163 8.59695 42.955 9.36273 43.7207C10.1285 44.4865 11.1671 44.9167 12.2501 44.9167H36.7501C37.833 44.9167 38.8716 44.4865 39.6374 43.7207C40.4032 42.955 40.8334 41.9163 40.8334 40.8334V15.3125L29.6042 4.08337Z"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke={color}
    />
    <path
      d="M28.5833 4.08337V16.3334H40.8332"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke={color}
    />
    <path
      d="M29 24.5L23.5 19L18 24.5"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke={color}
    />
    <path
      d="M23.4951 34.8889V19"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke={color}
    />
  </Svg>
)

DocumentUploadingIcon.propTypes = propTypes
DocumentUploadingIcon.defaultProps = defaultProps

export default DocumentUploadingIcon
